import ".././styles/Finance.css";
import meeting from ".././assets/annual-meeting.jpg";
import pccmlogo from ".././assets/pccm_logo.png";
import React, { useState, useEffect, useLayoutEffect } from 'react';

// --- Configuration for Google Sheets API ---
const GOOGLE_API_KEY = 'AIzaSyCLfnoX4kMuKDpNMQ9HZ2qJP28aRKNd2Hg';
const SPREADSHEET_ID = '16I9JOyUgHldKvU8AqhPl8ABxFRwBfb_mk37zbMhU1mU';
const CURRENT_REPORTS = 'currentReports!A:C';
const PAST_REPORTS = 'pastReports!A:C';

function Finance(){
    const [currentReport, setCurrentReport] = useState([]);
    const [pastReport, setPastReport] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
    
            try {
                //----- Current Reports -----
                const currentReportApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${CURRENT_REPORTS}?key=${GOOGLE_API_KEY}`;

                const currentReportResponse = await fetch(currentReportApiUrl);
    
                if (!currentReportResponse.ok) {
                    const errorJson = await currentReportResponse.json(); // Google API returns error as JSON
                    const errorMessage = errorJson.error ? errorJson.error.message : currentReportResponse.statusText;
                    throw new Error(`HTTP Error! Status: ${currentReportResponse.status} - ${errorMessage}`);
                }
    
                const currentReportJsonData = await currentReportResponse.json();
    
                if (currentReportJsonData && currentReportJsonData.values) {
                    // The first row of the sheet is the headers
                    const headers = currentReportJsonData.values[0];
                    const rows = currentReportJsonData.values.slice(1);
    
                    const currentReportParsedReports = rows.map(row => {
                        let reportSheet = {};
                        headers.forEach((header, index) => {
                            reportSheet[header.toLowerCase()] = row[index];
                        });
                        return reportSheet;
                    });
                    setCurrentReport(currentReportParsedReports);
                } else {
                    console.warn("Google Sheets API data not found or response is empty.", currentReportJsonData);
                    setCurrentReport([]);
                }

                //----- Past Reports -----
                const pastReportsApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${PAST_REPORTS}?key=${GOOGLE_API_KEY}`;

                const pastReportsResponse = await fetch(pastReportsApiUrl);
    
                if (!pastReportsResponse.ok) {
                    const errorJson = await pastReportsResponse.json(); // Google API returns error as JSON
                    const errorMessage = errorJson.error ? errorJson.error.message : pastReportsResponse.statusText;
                    throw new Error(`HTTP Error! Status: ${pastReportsResponse.status} - ${errorMessage}`);
                }
    
                const pastReportsJsonData = await pastReportsResponse.json();
                console.log(pastReportsJsonData);
    
                if (pastReportsJsonData && pastReportsJsonData.values) {
                    // The first row of the sheet is the headers
                    const headers = pastReportsJsonData.values[0];
                    const rows = pastReportsJsonData.values.slice(1);
    
                    const pastReportsParsedReports = rows.map(row => {
                        let reportSheet = {};
                        headers.forEach((header, index) => {
                            reportSheet[header.toLowerCase()] = row[index];
                        });
                        return reportSheet;
                    });
                    setPastReport(pastReportsParsedReports);
                } else {
                    console.warn("Google Sheets API data not found or response is empty.", pastReportsJsonData);
                    setPastReport([]);
                }
            } catch (err) {
                console.error("Error fetching programs and services:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };
    
        fetchData();
    }, []);
    
        // Only scroll when loading is false and no error occurred
        useLayoutEffect(() => {
            if (!loading && !error) {
                window.scrollTo(0, 0);
            }
        }, [loading, error]);
    
        if (loading) {
            return (
                <div className="loading">
                    <img src={pccmlogo} className="sml-logo" alt="pccm-logo"></img>
                    <p><b>Loading Finance & Reports page...</b></p>
                </div>
            );
        }
    
        if (error) {
            return (
                <div className="loading">
                    <h1>⚠︎</h1>
                    <p className="loading"><b>Error: {error.message}</b></p>
                    <div className="button-2" onClick={() => window.location.reload()}>Retry</div>
                </div>
            );
        }
    
    return(
        <>
            <div className="container">
                <div className="finance-banner-container" id="top">
                    <div className="finance-banner">
                        <h1>Finance and Reports</h1>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sub-container annual-report" id="annual-report">
                    <h2 className="section-title">Our Annual Report</h2>
                    <p>
                        In our annual report, we want to share a great overview of the progress we’ve made together through our programs and services. We deeply appreciate 
                        your support, which has allowed us to achieve so much and navigate the various events of the year. As we look ahead to the fiscal year {currentReport[0].fiscalyear}, 
                        running from April {currentReport[0].fiscalyear.slice(0,4)} to March {currentReport[0].fiscalyear.slice(5,9)}, we’re excited to share our plans for new 
                        initiatives that we believe will make a meaningful impact. Your generosity is instrumental in ensuring that every donation is used wisely and effectively, 
                        and we commit to maintaining transparency and accountability in our finances.
                    </p>
                    <a href={currentReport[0].link} target="_blank" rel="noopener noreferrer" className="button-1">Launch {currentReport[0].fiscalyear} Annual Report</a>
                </div>
            </div>
            <div className="container">
                <div className="sub-container finance-income" id="finance-income">
                    <div className="img-container">
                        <img src={meeting} className="image" alt="Annual General Meeting Picture"></img>
                    </div>
                    <div className="text-side">
                        <p>
                            <h2 className="section-title">Income Statement</h2>
                            We appreciate your unwavering support, and we want to be transparent about our income reporting to foster trust within our community. Our community-driven 
                            initiatives are inspired by the desire to create a better quality of life for all those we serve. This income statement serves as a reflection of the financial 
                            resources needed to not only sustain our valuable programs but also to ensure the ongoing maintenance of our community centre.
                        </p>
                        <a href={currentReport[1].link} target="_blank" rel="noopener noreferrer" className="button-2">Launch {currentReport[1].fiscalyear} Income Statement</a>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sub-container finance-balance" id="finance-balance">
                    <h2 className="section-title">Comparative Balance Sheet</h2>
                    <p>
                        This comparative balance sheet reflects how our financial position has evolved over the past year. We’re grateful to share that our current and fixed assets have remained 
                        steady—a true reflection of the generosity and trust our community has placed in us. Your support continues to be the foundation of our sustainability.
                        <br /><br />
                        At the same time, our current and long-term liabilities remind us of the responsibilities we carry in service of our mission. Your ongoing support—through donations, grants, 
                        and volunteer time—makes a real difference. It helps us stay financially balanced and focused on creating positive change together.
                    </p>
                    <a href={currentReport[2].link} target="_blank" rel="noopener noreferrer" className="button-1">Lanuch {currentReport[2].fiscalyear} Balance Sheet</a>
                </div>
            </div>
            <div className="container">
                <div className="sub-container past-reports" id="past-reports">
                    <h2 className="section-title">Past Reports & Statements</h2>
                    <div className="past-reports-list">
                        {pastReport.length > 0 ? (
                            pastReport.map((pastReport, index) => {
                                return(
                                    <a key={pastReport.id} href={pastReport.link} target="_blank" rel="noopener noreferrer">{pastReport.title}</a>
                                );
                            })
                        ) : (
                            <p>No past reports & statements are available.</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Finance;